import { IActivityJob, JobStatusEnum, MessageDeliveryStatusEnum } from '@novu/shared';

// SES-reported outcomes log as "Message ..." (WEBHOOK-sourced); a step never even attempted
// because a preference blocked its channel logs as "Step filtered by ..." (INTERNAL-sourced) -
// both are valid origins for a delivery status.
const DETAIL_TEXT_TO_DELIVERY_STATUS: Record<string, MessageDeliveryStatusEnum> = {
  'Message delivered': MessageDeliveryStatusEnum.DELIVERED,
  'Message bounced': MessageDeliveryStatusEnum.BOUNCED,
  'Message complaint': MessageDeliveryStatusEnum.COMPLAINT,
  'Message unsubscribed': MessageDeliveryStatusEnum.UNSUBSCRIBED,
  'Step filtered by subscriber global preferences': MessageDeliveryStatusEnum.CANCELED,
  'Step filtered by subscriber workflow preferences': MessageDeliveryStatusEnum.CANCELED,
  'Step filtered by workflow preferences': MessageDeliveryStatusEnum.CANCELED,
  'Step filtered by user preferences': MessageDeliveryStatusEnum.CANCELED,
};

export const getJobDeliveryStatuses = (job: IActivityJob): MessageDeliveryStatusEnum[] => {
  const statuses = new Set<MessageDeliveryStatusEnum>();

  for (const detail of job.executionDetails ?? []) {
    const status = DETAIL_TEXT_TO_DELIVERY_STATUS[detail.detail];
    if (status) {
      statuses.add(status);
    }
  }

  return [...statuses];
};

const DELIVERY_STATUS_PRIORITY: MessageDeliveryStatusEnum[] = [
  MessageDeliveryStatusEnum.COMPLAINT,
  MessageDeliveryStatusEnum.BOUNCED,
  MessageDeliveryStatusEnum.UNSUBSCRIBED,
  MessageDeliveryStatusEnum.CANCELED,
  MessageDeliveryStatusEnum.DELIVERED,
];

export const getPrimaryDeliveryStatus = (
  deliveryStatus?: MessageDeliveryStatusEnum[]
): MessageDeliveryStatusEnum | undefined => {
  if (!deliveryStatus?.length) return undefined;

  return DELIVERY_STATUS_PRIORITY.find((status) => deliveryStatus.includes(status));
};

export const getActivityStatus = (jobs: IActivityJob[]) => {
  if (!jobs.length) return JobStatusEnum.PENDING;

  const hasFailedJob = jobs.some((job) => job.status === JobStatusEnum.FAILED);

  if (hasFailedJob) {
    return JobStatusEnum.FAILED;
  }

  const lastJob = jobs[jobs.length - 1];

  if (lastJob.status === JobStatusEnum.SKIPPED || lastJob.status === JobStatusEnum.CANCELED) {
    const previousJobs = jobs.slice(0, -1);
    const hasPreviousCompletedJobs = previousJobs.some((job) => job.status === JobStatusEnum.COMPLETED);

    if (hasPreviousCompletedJobs || !previousJobs.length) {
      return JobStatusEnum.COMPLETED;
    }
  }

  return lastJob.status;
};
